import type { Nullable } from "../types";
import { guardArray } from "./guard-array";

export function filterNonNull<T>(array: Nullable<Nullable<T>[]>): T[] {
	const result = guardArray(array).filter((item) => !!item);
	return result as T[];
}
